import React from 'react';
import {AssetTypeFormProps} from '../interfaces';
import {
  ContainerNumberField,
  AssetSizeSelect,
  ChassisNumberField,
  ChassisLicensePlateField,
  DriverFields,
  ScacCodeField,
  TruckLicensePlateField,
  NotesField,
} from '../fields';

/**
 * Check-in form for Empty Container asset types.
 * Covers: CONTAINER_EMPTY, TRUCK_CONTAINER_EMPTY.
 *
 * Required fields: Container Number, Asset Size, Chassis Number,
 *                  Driver License Number, Driver First Name, Driver Last Name.
 */
const EmptyContainerForm: React.FC<AssetTypeFormProps> = ({form, errors, onValueChange, onAssetSizeChange}) => {
  return (
    <>
      <ContainerNumberField
        value={form.containerNumber}
        onValueChange={onValueChange}
        error={errors.containerNumber}
        required
      />
      <AssetSizeSelect
        value={form.assetSize}
        onChange={onAssetSizeChange}
        required
      />
      <ChassisNumberField
        value={form.chassisNumber}
        onValueChange={onValueChange}
        error={errors.chassisNumber}
        required
      />
      <ChassisLicensePlateField
        value={form.chassisLicensePlateNumber}
        onValueChange={onValueChange}
      />
      <DriverFields
        form={form}
        errors={errors}
        onValueChange={onValueChange}
        requireLicense
      />
      <ScacCodeField
        value={form.scacCode}
        onValueChange={onValueChange}
        error={errors.scacCode}
      />
      <TruckLicensePlateField
        value={form.truckLicensePlateNumber}
        onValueChange={onValueChange}
        error={errors.truckLicensePlateNumber}
      />
      <NotesField
        value={form.notes}
        onValueChange={onValueChange}
      />
    </>
  );
};

export default EmptyContainerForm;

